import { z } from 'zod';
/**
 * Instant — a point on the timeline, strict ISO-8601 with `Z` suffix.
 *
 * Wire format regex: `^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$`
 *
 * - Optional milliseconds MUST be exactly 3 digits when present.
 * - No mixed offsets (`+02:00`), no naked timestamps, no RFC-2822.
 * - Anchored `^...$` — trailing characters are rejected.
 */
export const InstantSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, 'must be ISO-8601 with Z suffix')
    .brand();
//# sourceMappingURL=instant.js.map